module.exports = __webpack_public_path__ + "quicksilver/static/media/icici.3405bfc4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/payments/banking/icici.svg
// module id = 638
// module chunks = 0